import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowUp } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { insertProfileVideoAction } from "../../../../store/ProfileVideoActions";
import { useAxiosInstance } from "../../../../services/Interceptor";
import { toast } from "react-toastify";
import { useState } from "react";

export default function UploadVideo({ profileVideo, savedVideos }) {
  const [uploadProgress, setUploadProgress] = useState(0);
  const resultFilter = savedVideos.filter(
    (item) => item.type === profileVideo.id,
  );
  const dispatch = useDispatch();
  const apiInstance = useAxiosInstance();

  const handleSubmitProfileVideo = async (event, profileVideoId) => {
    const file = event.target.files[0];
    if (!file) {
      toast.warn("No file selected. Please choose a video to upload.");
      return;
    }

    if (!file.type.startsWith("video/")) {
      toast.error("Invalid file type. Please upload a valid video file.", {});
      return;
    }

    const maxSizeInBytes = 600 * 1024 * 1024;
    if (file.size > maxSizeInBytes) {
      toast.warning("Video size should not exceed 600MB.", {
        position: "top-right",
      });
      return;
    }

    try {
      await dispatch(
        insertProfileVideoAction(
          apiInstance,
          file,
          profileVideoId,
          setUploadProgress,
        ),
      );
      toast.success("Video uploaded successfully!");
    } catch (error) {
      toast.error(
        "An error occurred while uploading the video. Please try again.",
      );
    }
  };

  return (
    resultFilter.length === 0 && (
      <div className="w-50">
        <div className="w-full flex flex-col items-center">
          <div className="w-full border border-blue-700 border-dashed rounded-lg cursor-pointer p-2">
            <label
              htmlFor={`video-${profileVideo.id}`}
              className="w-full flex flex-col items-center cursor-pointer"
            >
              <FontAwesomeIcon
                icon={faCircleArrowUp}
                size="lg"
                className="text-gray-500"
              />
              <p className="mb-2 text-xs text-gray-500 dark:text-gray-400">
                <span className="font-normal">Click to upload Video</span>
              </p>
              <input
                id={`video-${profileVideo.id}`}
                type="file"
                className="hidden"
                onChange={(e) => handleSubmitProfileVideo(e, profileVideo.id)}
                accept="video/*"
              />
            </label>
          </div>
          {uploadProgress > 0 && uploadProgress < 100 && (
            <div className="w-full mt-3">
              <div className="bg-gray-300 rounded-full h-2 w-full">
                <div
                  className="bg-green-600 h-2 rounded-full transition-all duration-300 ease-in-out"
                  style={{ width: `${uploadProgress}%` }}
                ></div>
              </div>
              <p className="text-xs text-gray-600 mt-1 text-right pr-1">
                Uploading: {uploadProgress}%
              </p>
            </div>
          )}
        </div>
      </div>
    )
  );
}
